import { render, staticRenderFns } from "./top-section4.vue?vue&type=template&id=5350a49b&scoped=true&"
import script from "./top-section4.vue?vue&type=script&lang=ts&"
export * from "./top-section4.vue?vue&type=script&lang=ts&"
import style0 from "./top-section4.vue?vue&type=style&index=0&id=5350a49b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5350a49b",
  null
  
)

export default component.exports